<template>
  <div>
    <h3 v-if="showDescriptionTitle" class="invoice-description-title">
      Description
    </h3>

    <div v-if="description"
         class="invoice-description-text"
         v-html="description" />
    <AttachedFiles v-if="invoiceAttachments" :invoice-attachments="invoiceAttachments" />
  </div>
</template>

<script>
import AttachedFiles from "./AttachedFiles.vue";

export default {
  name: "InvoiceDescriptionAndAttachedFiles",

  components: {
    AttachedFiles
  },

  props: {
    description: { type: String },
    invoiceAttachments: { type: Array }
  },

  computed: {
    showDescriptionTitle () {
      return this.description || this.invoiceAttachments.length;
    }
  }
};
</script>
